import { inject, Injectable } from '@angular/core';
import { Cart } from '@spartacus/cart/base/root';
import { combineLatest, map, Observable } from 'rxjs';

import { CustomDeliveryMode } from '../models/custom-delivery-mode.model';
import { OrderTypeEnum } from '../enums/order-type.enum';
import { NshiftMapper } from '../mappers/nshift.mapper';
import { BaseStoreService } from './base-store.service';
import { NshiftService } from './nshift.service';
import { AdyenService } from './adyen.service';

@Injectable({
  providedIn: 'root'
})
export class ExpressDeliveryModeService {
  private readonly nShiftService = inject(NshiftService);
  private readonly nShiftMapper = inject(NshiftMapper);
  private readonly adyenService = inject(AdyenService);
  private readonly baseStoreService = inject(BaseStoreService);

  getExpressDeliveryModes(cart: Cart, zipcode: string, countryIsoCode: string): Observable<CustomDeliveryMode[]> {
    const country = { isocode: countryIsoCode };
    const isNShiftEnabled = this.baseStoreService.baseStore.enableNshift;
    const isExtlog = cart.orderType === OrderTypeEnum.EXTLOG;

    const adyenExpressCheckoutDeliveryModes$ = this.adyenService.getAdyenExpressCheckoutDeliveryModes(cart.code, cart.guid, zipcode);

    if (isNShiftEnabled && isExtlog && zipcode && country) {
      const nshift$ = this.nShiftService.getNshiftOptions(cart, zipcode, country).pipe(
        map((nshiftOptions) => this.nShiftMapper.toDeliveryModes(nshiftOptions))
      );

      return combineLatest([nshift$, adyenExpressCheckoutDeliveryModes$]).pipe(
        map(([nshiftDeliveryModes, adyenExpressCheckoutDeliveryModes]) => (
          nshiftDeliveryModes.filter((modeNshift) => adyenExpressCheckoutDeliveryModes.some((mode) => mode.code === modeNshift.code))
        )));
    }

    return adyenExpressCheckoutDeliveryModes$;
  }
}
